import React, {ChangeEvent, useState} from 'react';
import {Button, Flex} from 'antd';
import {
    ArrowClockwise,
    ArrowCounterClockwise,
    ArrowLineUp,
    ArrowsCounterClockwise,
    Camera,
    DownloadSimple,
    FloppyDisk,
    Gear,
    UploadSimple,
    X
} from '@phosphor-icons/react';
import {useCurrentUser} from "../../../../contexts/UserContext";
import {useViewerStore} from '../../../../store/store';
import SingleModuleValidation from "../Modal/Modal-Content/SingleModuleValidation";
import FinaliseConfirm from "../Modal/Modal-Content/FinaliseConfirm";
import CertificationValidation from "../Modal/Modal-Content/CertificationValidation"
import LockedDesignValidation from "../Modal/Modal-Content/LockedDesignValidation"
import {IoIosLock} from "react-icons/io";
import {CheckSingleModuleRoofs} from "../Three-JS-Viewer/Controllers/ModuleControl";
import RoofPitchValidation from "../Modal/Modal-Content/RoofPitchValidation";
import TreePositionValidation from "../Modal/Modal-Content/TreePositionValidation";
import { ModuleMesh, RoofMesh } from '../../../../@types/types';
import * as THREE from 'three';
import {clickButtonWithRef, registerRef} from "../../../../helpers/storeHelpers";
import {checkIfAnyRoofHasModulesOverSetbackLines} from "../Three-JS-Viewer/Controllers/PathwayControl";
import ModuleOverSetbackValidation from "../Modal/Modal-Content/ModuleOverSetbackValidation";

const Actionbar = () => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);
    const {user, hasCapability} = useCurrentUser();
    const isPushPullMode = useViewerStore((state) => state.isPushPullMode);
    const vendor = useViewerStore(state => state.selectedLossesVendor);
    const isBallastedRackingMeeting25percentRule = useViewerStore((state) => state.isBallastedRackingMeeting25percentRule);


    const selRoofFaceArr = useViewerStore((state) => state.selRoofFaceArr);
    const {designList, selectedDesignIndex} = useViewerStore(state => state);
    const [isOpen, setIsOpen] = useState(true);
    const stage = sessionStorage.getItem('currentStage');


    const exportGltf = () => {
        sceneViewer.downloadGLTF();
    }

    const importGltf = () => {
        clickButtonWithRef("gltfImport");
    }


    const pushPullHandler = () => {
        if (isPushPullMode) {
            sceneViewer.setPushPullMode(false);

            document.body.style.cursor = 'default';
        } else {
            sceneViewer.setPushPullMode(true);

            document.body.style.cursor = 'grab';
        }
        sceneViewer?.viewerAlert({
            show: !isPushPullMode,
            title: "Push Pull Tool Active",
            message: `Select a Tree or Obstruction and drag to extrude height of tree or obstruction. Press 'Esc' to exit.`,
            messageType: "info",
            isModal: false,
        });
    };

    const importGLBFile = (e: ChangeEvent<HTMLInputElement>) => {
        if(e.target.files && e.target.files[0]) sceneViewer.importGLBFile(e.target.files[0]);
    };

    const checkSelFaceArr = () => {
        const cloneFaceArr = [...selRoofFaceArr];
        cloneFaceArr.forEach(face => {
            face.moduleCount = face.children.filter((item: any) => {
                return item.module
            }).length;
        });
        useViewerStore.setState({selRoofFaceArr: cloneFaceArr});
    };

    const clickSnapShot = () => {
        const canvas = sceneViewer.renderer.domElement;
        const dataURL = canvas.toDataURL('image/png');
        let a = document.createElement('a');
        a.href = dataURL
        a.download = 'oneDRAWScreenshot.png';
        a.click();
    };

    const handleUndo = () => {
        sceneViewer.setStep(-1);
        setTimeout(() => {
            checkSelFaceArr();
        }, 0);
    };

    const handleRedo = () => {
        sceneViewer.setStep(1)
        setTimeout(() => {
            checkSelFaceArr();
        }, 0);
    };

    const handleRefresh = () => {
        sceneViewer.refreshShade();


    };

    const checkFinaliseConfirmation = () => {
        if (designList[0]?.Design_Certification_Status
            && designList[0]?.Design_Certification_Status !== "Not Certified"
            && designList[0]?.Design_Certification_Status !== null) {
            if (hasCapability("Pre_Installed_Certified")
                || hasCapability("Install_Change_Certified")
                || hasCapability("As_Built_Certified")
                || hasCapability("Certified_Design_Override")) {
                if (designList[0]?.Design_Certification_Status !== "Certified Design Override") {
                    sceneViewer.viewerAlert({
                        show: true,
                        title: <span style={{display: "flex"}}><IoIosLock
                            size={25}/> {designList[0]?.Design_Certification_Status}</span>,
                        message: <CertificationValidation confirm={finaliseSave}
                                                          certification_status={designList[0]?.Design_Certification_Status}/>,
                        messageType: "success",
                        isModal: true
                    })
                } else {
                    finaliseSave()
                }
            } else {
                sceneViewer.viewerAlert({
                    show: true,
                    title: <span style={{display: "flex"}}><IoIosLock
                        size={25}/> {designList[0]?.Design_Certification_Status}</span>,
                    message: <LockedDesignValidation certification_status={designList[0]?.Design_Certification_Status}/>,
                    messageType: "success",
                    isModal: true
                })
            }
        } else {
            finaliseSave()
        }

    }

    const finaliseSave = () => {


        const roofs = CheckSingleModuleRoofs(sceneViewer.roofMeshArr);

        const doesDesignContainBallastedRacking = sceneViewer.moduleMeshArr.filter((module: ModuleMesh) => module.userData.isBallastedRackType).length > 0;
        if (doesDesignContainBallastedRacking && !isBallastedRackingMeeting25percentRule) {
            sceneViewer.viewerAlert({
                show: true,
                title: "25% Rule Violation for Ballasted Racking",
                message: "The design contains ballasted racking. Please ensure that the ballasted racking meets the 25% rule for the design to be finalized",
                messageType: "error",
                isModal: true
            });
            return

        }


        const isUserHaveSetbackOverrideCapability = useViewerStore.getState().isUserHaveCapabilityToAddPanelsPastSetbacks

        const checkIfModulesAreOverSetback = checkIfAnyRoofHasModulesOverSetbackLines()



        if (!isUserHaveSetbackOverrideCapability && checkIfModulesAreOverSetback) {
            sceneViewer.viewerAlert({
                show: true,
                title: "Error : Modules Over Setback Lines",
                message:<ModuleOverSetbackValidation/>,
                messageType: "error",
                isModal: true
            });
            return
        }



        if (roofs.length > 0) {

            sceneViewer.viewerAlert({
                show: true,
                title: "Single Module Array",
                message: <SingleModuleValidation roofs={roofs}/>,
                messageType: "success",
                isModal: true
            })


        } else {

            const roofsHavingModulesOnSteepRoof = sceneViewer.roofMeshArr.filter((roof: RoofMesh) => {
                return roof.oriAng.tilt > 50 && roof?.moduleArr?.length > 0;
            })


            const isTreeCollidingWithRoof = sceneViewer.treeGroup.children.filter((tree: THREE.Object3D) => {
                return  tree.children[0].userData.isCollidingWithRoof
            })


            if (roofsHavingModulesOnSteepRoof.length > 0) {
                sceneViewer.viewerAlert({
                    show: true,
                    title: "Steep Roof Surface Design",
                    message: <RoofPitchValidation roofs={roofsHavingModulesOnSteepRoof}/>,
                    messageType: "success",
                    isModal: true
                })
            }
            else if (isTreeCollidingWithRoof.length > 0) {
                sceneViewer.viewerAlert({
                    show: true,
                    title: "Tree Position Warning",
                    message: <TreePositionValidation/>,
                    messageType: "success",
                    isModal: true
                })

            }

            else {
                sceneViewer.viewerAlert({
                    show: true,
                    title: "Save Design",
                    message: <FinaliseConfirm/>,
                    messageType: "success",
                    isModal: true
                })
            }
        }

    }

    return (
        <div className='toolbar actions'>
            {
                user ?
                    <Flex gap={15}>

                        <Button
                            title={!isOpen ? "Close Actionbar" : "Open Actionbar"}
                            type='default'
                            size='large'
                            icon={isOpen ? <Gear size={28} weight='fill'/> : <X size={28} weight='bold'/>}
                            onClick={() => setIsOpen(!isOpen)}
                        />

                        <Flex gap={5} hidden={isOpen}>
                            {hasCapability('Undo') && (
                                <Button
                                    ref={registerRef("undoBtn")}
                                    title={"Undo"}
                                    type='default'
                                    size='large'
                                    icon={<ArrowCounterClockwise size={26} weight='fill'/>}
                                    onClick={handleUndo}
                                    property='StepUndo'
                                />
                            )}
                            {hasCapability('Redo') && (
                                <Button
                                    ref={registerRef("redoBtn")}
                                    title={"Redo"}
                                    type='default'
                                    size='large'
                                    icon={<ArrowClockwise size={26} weight='fill'/>}
                                    onClick={handleRedo}
                                    property='StepRedo'
                                />
                            )}
                            {hasCapability('Download_GLB') && (
                                <Button
                                    title={"Download GLB File"}
                                    type='default'
                                    size='large'
                                    icon={<DownloadSimple size={26} weight='fill'/>}
                                    onClick={exportGltf}
                                />
                            )}
                            {hasCapability('Download_GLB') && (
                            <Button
                                title={"Import GLB File"}
                                type='default'
                                size='large'
                                icon={<UploadSimple size={26} weight='fill'/>}
                                onClick={importGltf}
                            />
                            )}
                            {hasCapability('Refresh_Shade') && (
                                <Button
                                    title={"Refresh Shade"}
                                    type='default'
                                    size='large'
                                    icon={<ArrowsCounterClockwise size={26} weight='fill'/>}
                                    onClick={handleRefresh}
                                />
                            )}
                            {hasCapability('Push_Pull Tool') && (
                                <Button
                                    ref={registerRef("pushPullToolBtn")}
                                    title={"Push Pull Tool"}
                                    type={isPushPullMode ? 'primary' : 'default'}
                                    size='large'
                                    icon={<ArrowLineUp size={26} weight='fill'/>}
                                    onClick={pushPullHandler}
                                />
                            )}
                            {hasCapability('Snapshot') && (
                                <Button
                                    title={"Snapshot"}
                                    type='default'
                                    size='large'
                                    icon={<Camera size={26} weight='fill'/>}
                                    id='snapShotBtn'
                                    onClick={clickSnapShot}
                                />
                            )}
                            {

                                ((hasCapability('Finalize') && stage && Number(stage) < 4) ||
                                    (hasCapability('Finalize') && stage && Number(stage) >= 4 && hasCapability('Stage_4_Post_Contract_Finalize')))
                                && <Button
                                    title={"Save Design"}
                                    type='primary'
                                    size='large'
                                    icon={<FloppyDisk size={26} weight='fill'/>}
                                    onClick={checkFinaliseConfirmation}
                                >Finalize</Button>}
                            <input ref={registerRef("gltfImport")} type='file' accept='.zip' onChange={importGLBFile}  hidden/>

                        </Flex>
                    </Flex>
                    : ""
            }
        </div>
    );
}

export default Actionbar;